import React from 'react';
import { connect } from 'react-redux';
import { Tooltip, Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { mediaPickerActions } from '../store';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { MEDIA_USAGE_TYPE } from '../../CreatePageConstants';
import { createActions } from '../../store';

const styles = theme => ({
    icon: {
        marginRight: theme.spacing(1)
    },
    button: {
        marginLeft: theme.spacing(1)
    }
});

const RemoveMediaButton = (props) => {
    const { classes, title, mediaUsageType, setProperty, savingInProgress, logoVisible, updateVisualizerSettings } = props;

    const onRemoveMediaClick = () => {
        switch(mediaUsageType) {
            case MEDIA_USAGE_TYPE.LOGO: {
                setProperty('logoMediaPickerOpen', false);
                updateVisualizerSettings({ logoVisible: false });
                break;
            }
            case MEDIA_USAGE_TYPE.BACKGROUND: {
                setProperty('backgroundMediaPickerOpen', false);
                // This option is not available for background for now.
                break;
            }
        }
    };

    return (
        <Tooltip
            title={`The logo will be hidden. Change the logo size or select a new one to see it again.`}
            placement='top'
            arrow
        >
            <Button 
                className={classes.button}
                size='large' 
                variant='outlined'
                color='inherit'
                onClick={onRemoveMediaClick}
                disabled={savingInProgress || !logoVisible}
                startIcon={<VisibilityOffIcon className={classes.icon} />}
            >
                {title}
            </Button>
        </Tooltip>
    );
};

const mapStateToProps = (state) => {
    const { savingInProgress } = state.create.videoSavingState;
    const { logoVisible } = state.createPreview.present.videoSettings.visualizer;
    return { savingInProgress, logoVisible };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));

    return { 
        setProperty, 
        updateVisualizerSettings
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(RemoveMediaButton, styles));